// Module content wired verbatim from 01-core-training.md.
// videoUrl is an optional embed slot the owner fills later.
export const MODULES = [
  {
    id: 1,
    title: "The Model (Why This Works)",
    videoUrl: "",
    bigIdea: "Businesses don't buy AI. They buy outcomes: revenue, leads, retention, margin.",
    talkingPoints: [
      "The AI gold rush has two groups: people selling tools and people selling results. Tool sellers compete on price. Result sellers compete on value.",
      "The technology has been commoditized. A chatbot, a voice agent, an automation workflow all cost almost nothing to build now. What has NOT been commoditized is packaging.",
      "The skill you're buying in this program is not technical. It's the ability to identify a funded pain, wrap a cheap system around it, and price it against the outcome.",
      "Rule to write down: You are never selling software. You are selling the employee the software replaces or the revenue the software creates.",
    ],
    homework: "None. Move to Module 2.",
  },
  {
    id: 2,
    title: "The Trap (What Not to Do)",
    videoUrl: "",
    bigIdea: "The AI agency model is a job with extra steps.",
    talkingPoints: [
      "The default path everyone takes: learn a tool, offer \"AI services,\" custom-build for every client, charge monthly retainers, rebuild everything for the next client.",
      "Why it fails: no leverage. Every client adds hours. You become a freelancer with overhead.",
      "The second trap: becoming a developer. Six months of tutorials to build what a specialist would build for a few hundred dollars.",
      "The Owner's Path instead: ONE offer, ONE delivery system, built ONCE by someone else, sold repeatedly. Your hours stay flat while revenue climbs.",
    ],
    homework: "Write down which trap you were about to fall into. Most people were about to fall into one of them.",
  },
  {
    id: 3,
    title: "Market Selection (Friday Night)",
    videoUrl: "",
    bigIdea: "Pick a market that is already spending money on this exact pain.",
    talkingPoints: [
      "Three filters, in order: (1) Funded: they have revenue and budgets, (2) Painful: the problem costs them money every single week, (3) Reachable: you can get 50 of them on a list by Sunday.",
      "Do not invent demand. Find existing spend and redirect it. If they're paying a human $3,000/mo to do it badly, your $5,000 system that does it better is an easy conversation.",
      "Use Asset 02 (the Market List). Pick ONE. Committing to one market for 30 days is a feature, not a limitation. Niching is what allows premium pricing.",
      "Disqualify markets you'd hate talking to. You will be having a lot of conversations.",
    ],
    homework: "Pick your market from Asset 02. Write one sentence: \"I help [market] fix [pain].\"",
  },
  {
    id: 4,
    title: "Pain Research (Saturday Morning)",
    videoUrl: "",
    bigIdea: "Sell in their words, not yours.",
    talkingPoints: [
      "Your prospects have already described the offer they want to buy. It's sitting in reviews, forums, job posts, and Facebook groups. Your job is retrieval, not creativity.",
      "Run the prompts in Asset 03. You're hunting for: the dollar cost of the pain, the emotional language around it, the failed solutions they've already tried, and the outcome they fantasize about.",
      "The gold is in failed solutions. \"We tried hiring a VA and it didn't work\" tells you exactly how to position: not as another VA, but as the thing that doesn't quit, doesn't sleep, and doesn't need training twice.",
    ],
    homework: "Complete the Pain Research Sheet at the bottom of Asset 03.",
  },
  {
    id: 5,
    title: "Packaging & Positioning (Saturday Afternoon)",
    videoUrl: "",
    bigIdea: "Price the outcome, not the tool.",
    talkingPoints: [
      "Walk through the Positioning Ladder in Asset 04: Tool \u2192 Service \u2192 System \u2192 Outcome. Each rung roughly doubles what you can charge.",
      "Name your offer after the result. \"AI Chatbot\" is a tool name. \"24/7 Lead Conversion System\" is an outcome name. Same tech, different bank account.",
      "Anchor against the alternative they already understand: a salary, a lost deal, a churned customer. $5,000 sounds expensive next to software. It sounds cheap next to a $45,000 hire.",
      "Build your offer using the One-Page Offer Doc template in Asset 04. That single page becomes your sales asset, your build spec, and your positioning statement.",
    ],
    homework: "Complete your One-Page Offer Doc.",
  },
  {
    id: 6,
    title: "The Build Handoff (Sunday Morning)",
    videoUrl: "",
    bigIdea: "You are the architect, not the contractor.",
    talkingPoints: [
      "Everything in your One-Page Offer Doc translates directly into a freelancer job post. Asset 05 gives you the post template, the filtering criteria, and the interview questions.",
      "Budget guidance: most first delivery systems can be built for a few hundred dollars using existing platforms (chat platforms, automation tools, voice agents). You are assembling, not inventing.",
      "The ownership rule: you pay once, you own the system, the templates, and the documentation. That's in the contract language provided.",
      "Do NOT wait for the build to finish before selling. The build and the pipeline run in parallel. Your first client conversation can happen before the system exists.",
    ],
    homework: "Post the job using Asset 05. Set your budget cap.",
  },
  {
    id: 7,
    title: "Open the Pipeline (Sunday Night)",
    videoUrl: "",
    bigIdea: "Conversations, not campaigns.",
    talkingPoints: [
      "Your first 5 clients come from direct conversations, not ads and not content. Asset 08 gives you the outreach messages and the full enrollment call script.",
      "The enrollment call runs on four stages: Connect, Awareness, Resolve, Enroll. You are not pitching. You are diagnosing an expensive problem and prescribing your system.",
      "Volume math for your first 30 days: 20 outreach touches a day, expect 10 to 15 conversations a week, 4 to 6 calls booked, 1 to 2 closes. At $5,000 each, one close pays for this program 50 times over.",
      "Track everything. What you track improves.",
    ],
    homework: "Send your first 20 outreach messages tonight. You are now open for business.",
  },
];
